import { useState, useCallback, useMemo } from 'react'
import useSWR from 'swr'

import useFunctions from './useFunctions'

const useHttpFunction = (pathname) => {
  const functions = useFunctions()

  const fetcher = useCallback((url, config) => {
    return fetch(url, Object.assign({}, config))
      .then(async response => {
        if (response.ok) {
          return response.json()
        }
        // convert non-2xx HTTP responses into errors:
        const errorText = await response.text()
        const error = new Error(errorText);
        error.response = response;
        return Promise.reject(error);
      })
      .catch(e => {
        console.error(e.message)
      })
  }, [])
  const remoteUrl = useMemo(() => {
    if (!functions) return null
    const {
      region,
      app: { options: { projectId } },
    } = functions
    let base = `https://${region}-${projectId}.cloudfunctions.net`
    if (functions.emulatorOrigin) {
      base = `${functions.emulatorOrigin}/${projectId}/${region}`
    }
    return base + pathname
  }, [functions, pathname])
  return useSWR(remoteUrl, fetcher)
}

export default useHttpFunction
